import { __decorate } from "tslib";
import { attr, customElement, FASTElement, html } from '@microsoft/fast-element';
import { Presence } from '@getgo/chameleon-core';
import { SVG_CLOCK_ACTIVE, SVG_PRESENCE_AVAILABLE, SVG_PRESENCE_BUSY_ACTIVE, SVG_PRESENCE_DND, SVG_PRESENCE_OFFLINE, SVG_CLOSE_CIRCLE_INACTIVE, } from '@getgo/chameleon-icons';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import styles from './PresenceIndicator.styles.scss';
const icon = (presence) => {
    switch (presence) {
        case Presence.AVAILABLE:
            return html `${SVG_PRESENCE_AVAILABLE}`;
        case Presence.BUSY:
            return html `${SVG_PRESENCE_BUSY_ACTIVE}`;
        case Presence.AWAY:
            return html `${SVG_CLOCK_ACTIVE}`;
        case Presence.DND:
            return html `${SVG_PRESENCE_DND}`;
        case Presence.OFFLINE:
            return html `${SVG_PRESENCE_OFFLINE}`;
        case Presence.DISCONNECTED:
            return html `${SVG_CLOSE_CIRCLE_INACTIVE}`;
    }
};
const template = html `<div
  class="goto-presence-indicator goto-presence-indicator--${(x) => x.presence} ${(x) => x.hasAttribute('achromatic') ? 'goto-presence-indicator--achromatic' : ''}"
>
  <chameleon-svg>${(x) => icon(x.presence)}</chameleon-svg>
</div>`;
export const presenceIndicatorDefinition = {
    name: 'chameleon-presence-indicator',
    template,
    styles,
};
let PresenceIndicatorComponent = class PresenceIndicatorComponent extends ChameleonElementMixin(FASTElement) {
    constructor() {
        super(...arguments);
        this.presence = Presence.OFFLINE;
        this.achromatic = false;
    }
};
__decorate([
    attr
], PresenceIndicatorComponent.prototype, "presence", void 0);
__decorate([
    attr
], PresenceIndicatorComponent.prototype, "achromatic", void 0);
PresenceIndicatorComponent = __decorate([
    customElement(presenceIndicatorDefinition)
], PresenceIndicatorComponent);
export { PresenceIndicatorComponent };
